import z from 'zod';

export const WorkstationGroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    warehouseLocationId: z.string(),
});

export type WorkstationGroup = z.infer<typeof WorkstationGroupSchema>;
